import { firebaseAction } from 'vuexfire'
import { db } from '@/db'

const subcategories = db.collection('subcategories')

const state = {
  subcategories: [],
  currentSubcategories: []
}

const actions = {
  getCurrentSubcategories: firebaseAction(({ bindFirebaseRef }, categoryId) => {
    bindFirebaseRef('currentSubcategories',
      subcategories
        .where('categoryId', '==', categoryId)
        .orderBy('order')
    )
  }),

  getAllSubcategories: firebaseAction(({ bindFirebaseRef }) => {
    bindFirebaseRef('subcategories',
      subcategories.orderBy('categoryId')
    )
  })
}

const getters = {
  subcategoriesByCategoryId (state) {
    return categoryId => state.subcategories.filter(item => {
      return item.categoryId === categoryId
    }).sort((a, b) => a.order - b.order)
  },

  currentSubcategories (state) {
    return state.currentSubcategories.sort((a, b) => a.order - b.order)
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  actions,
  getters
}
